import api from './client';
import { Notification } from '../types';

export const notificationApi = {
  list: () => api.get<Notification[]>('/api/notifications'),
  unreadCount: () => api.get<{ count: number }>('/api/notifications/unread-count'),
  markAllRead: () => api.post('/api/notifications/mark-all-read'),
  markOneRead: (id: string) => api.post(`/api/notifications/${id}/read`),
};
